import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-cloneable', 'addRow', 'Pievienot');
Labels.set('ui-table-cloneable', 'removeRow', 'Dzēst rindu');
